module.exports = __webpack_public_path__ + "static/media/injuredQuestion.67be1746.mp3";